<template>
  <sc-page-base title="Logs">
    <div class="page-logs__wrap-content">

      <section
        v-for="(log, index) of logs"
        :key="index"
        class="page-logs__wrap-content__item">

        <sc-card
          class="page-logs__card"
          :link="true">

          <template slot="image">
            <figure
              class="page-logs__card__figure">

              <router-link
                class="page-logs__card__link"
                :to="{ name: log.pathName }">
                <img
                  class="page-logs__card__image"
                  :src="log.image" />
              </router-link>

            </figure>
          </template>

          <template slot="body">
            <div class="page-logs__card__content">
              <p class="title is-6">
                <router-link
                  :to="{ name: log.pathName }"
                  class="page-logs__card__full-link">
                  <span class="has-text-truncated page-logs__card__full-link__text">{{ log.title }}</span>
                  <sc-icon :icon="log.icon"/>
                </router-link>
              </p>
            </div>
          </template>
        </sc-card>

      </section>
    </div>
  </sc-page-base>
</template>

<script>
  import {
    ScPageBase,
    ScCard,
    ScIcon,
  } from '@intelipost-js/secure-components';

  export default {
    name: 'page-logs',
    data() {
      return {
        logs: [
          {
            title: 'Logs da API',
            pathName: 'logs-api',
            icon: 'code',
            image: '/static/images/logo-intelipost.png',
          },
          {
            title: 'Logs de Rastreamento',
            pathName: 'logs-tracking',
            icon: 'code',
            image: '/static/images/logo-intelipost.png',
          },
          {
            title: 'Logs de Reversa',
            pathName: 'logs-reverse',
            icon: 'code',
            image: '/static/images/logo-intelipost.png',
          },
        ],
      };
    },
    components: {
      ScPageBase,
      ScCard,
      ScIcon,
    },
  };
</script>

<style lang="scss" scoped>
  @import "~@intelipost-js/secure-ui/src/scss/variables"; // eslint-disable-line

  $animationEaseInOut: all ease-in-out 0.3s;

  .page-logs {
    &__wrap-content {
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-start;

      @media (max-width: 768px) {
        flex-direction: column;
      }

      &__item {
        flex-grow: 0;
        width: 330px;
        padding: 1rem;

        @media (min-width: 1250px) {
          height: 312px;
        }

        @media (max-width: 768px) {
          padding: 1rem 0;
        }

        @media (max-width: 500px) {
          width: 280px;
        }
      }
    }

    &__card {
      height: 280px;
      min-height: 280px;
      transition: $animationEaseInOut;

      @media (max-width: 768px) {
        height: 305px;
      }

      @media (max-width: 500px) {
        height: 268px;
        min-height: auto;
      }

      &__full-link {
        &__text {
          line-height: 22px;
          max-width: 240px;
        }
      }

      &__content {
        transition: $animationEaseInOut;
      }

      &__link {
        display: flex;
        align-items: center;
        justify-content: center;

        height: 222px;
        width: 100%;
        opacity: 1;
        transition: $animationEaseInOut;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/PageLogs.vue?b80e1cce